import { testimonials } from '../../../mocks/testimonials';

export default function LandingTestimonials() {
  return (
    <section id="testimonials" className="py-20 lg:py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="text-xs font-bold uppercase tracking-widest text-orange-500 mb-3 block">
            Real Results
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            What Business Owners Are Saying About Our AI Ad Generator
          </h2>
          <p className="text-base text-stone-500">
            Don&apos;t take our word for it — hear from small business owners, contractors, and agencies
            who use AdForge every single day.
          </p>
        </div>

        {/* Testimonial grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {testimonials.map((t, idx) => (
            <article
              key={t.id}
              className={`bg-white rounded-2xl border border-stone-100 p-7 ${
                idx === 0 ? 'md:col-span-2 lg:col-span-1' : ''
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-base" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-stone-700 text-sm leading-relaxed mb-6 italic">
                &ldquo;{t.content}&rdquo;
              </blockquote>

              {/* Author */}
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <div className="text-sm font-bold text-stone-900">{t.name}</div>
                  <div className="text-xs text-stone-400">{t.role}</div>
                </div>
                <div className="ml-auto">
                  <span className="text-xs font-semibold bg-orange-50 text-orange-600 px-2.5 py-1 rounded-full">
                    {t.business}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Trust badges */}
        <div className="mt-14 flex flex-wrap justify-center items-center gap-6 sm:gap-10">
          {[
            { icon: 'ri-shield-check-line', label: 'SOC2 Compliant' },
            { icon: 'ri-lock-password-line', label: 'Secure & Private' },
            { icon: 'ri-customer-service-2-line', label: '24/7 Support' },
            { icon: 'ri-refund-2-line', label: '30-Day Guarantee' },
            { icon: 'ri-award-line', label: '#1 Rated AI Ad Tool' },
          ].map((badge) => (
            <div key={badge.label} className="flex items-center gap-2 text-stone-500">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className={`${badge.icon} text-orange-400 text-base`} />
              </div>
              <span className="text-xs font-semibold">{badge.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
